var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 29.5C0.75 13.2076 13.9576 0 30.25 0C46.5424 0 59.75 13.2076 59.75 29.5C59.75 45.7924 46.5424 59 30.25 59C13.9576 59 0.75 45.7924 0.75 29.5ZM15.8687 24.5219L15.8687 44.25H22.1375L22.1375 24.5219H15.8687ZM15.5 18.2531C15.5 20.2812 16.975 21.7563 19.0031 21.7563C21.0313 21.7563 22.5063 20.2812 22.5063 18.2531C22.5063 16.225 21.0313 14.75 19.0031 14.75C17.1594 14.75 15.5 16.225 15.5 18.2531ZM38.7313 44.25H44.6313V32.0813C44.6313 25.9969 40.9437 23.9687 37.4406 23.9687C34.3062 23.9687 32.0938 25.9969 31.5406 27.2875V24.5219H25.6406L25.6406 44.25H31.9094V33.7406C31.9094 30.975 33.7531 29.5 35.5969 29.5C37.4406 29.5 38.7313 30.4219 38.7313 33.5562V44.25Z",
    fill: "#9C7DF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5b21c144330cfb1ac3ff7f8a9847f442.svg";
export { ForwardRef as ReactComponent };